/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestNinjaOneConnection200Response
 */
export interface TestNinjaOneConnection200Response {
    /**
     * 
     */
    success: boolean;
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    organizationCount?: number;
}

/**
 * Check if a given object implements the TestNinjaOneConnection200Response interface.
 */
export function instanceOfTestNinjaOneConnection200Response(value: object): value is TestNinjaOneConnection200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TestNinjaOneConnection200ResponseFromJSON(json: any): TestNinjaOneConnection200Response {
    return TestNinjaOneConnection200ResponseFromJSONTyped(json, false);
}

export function TestNinjaOneConnection200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestNinjaOneConnection200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'organizationCount': json['organizationCount'] == null ? undefined : json['organizationCount'],
    };
}

export function TestNinjaOneConnection200ResponseToJSON(json: any): TestNinjaOneConnection200Response {
    return TestNinjaOneConnection200ResponseToJSONTyped(json, false);
}

export function TestNinjaOneConnection200ResponseToJSONTyped(value?: TestNinjaOneConnection200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'organizationCount': value['organizationCount'],
    };
}

